import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const MandatoryDisclosure = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- Form STATE ---------------- */
    const [form, setForm] = useState();

    /* ---------------- TABLE ROWS STATE ---------------- */
    const defaultSections = {
        general_information: [{ information: "", details: "" }],
        documents_information: [{ information: "", details: "" }],
        result_academics: [{ information: "", details: "" }],
        result_class_x: [
            {
                year: "",
                registered: "",
                passed: "",
                percentage: "",
                remark: ""
            }
        ],
        result_class_xii: [
            {
                year: "",
                registered: "",
                passed: "",
                percentage: "",
                remark: ""
            }
        ],
        staff_information: [{ information: "", details: "" }],
        infrastructure_information: [{ information: "", details: "" }]
    };


    const [sections, setSections] = useState(defaultSections);

    /* ---------------- FETCH DATA ---------------- */

    const fetchSection = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${baseAPIUrl}admin/academic_page/get_mandatory_disclosure/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                setSections({
                    ...defaultSections,
                    ...res.data.data
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSection();
    }, []);



    /* ---------------- Input Change ---------------- */

    // row handler
    const handleChange = (section, index, field, value) => {
        const updated = { ...sections };
        updated[section][index][field] = value;
        setSections(updated);
    };

    // + Add Row
    const addRow = (section) => {
        let newRow = { information: "", details: "" };

        if (section === "result_class_x") {
            newRow = {
                year: "",
                registered: "",
                passed: "",
                percentage: "",
                remark: ""
            };
        }

        if (section === "result_class_xii") {
            newRow = {
                year: "",
                registered: "",
                passed: "",
                percentage: "",
                remark: ""
            };
        }

        setSections({
            ...sections,
            [section]: [
                ...sections[section],
                newRow
            ]
        });
    };

    const deleteRow = (section, index) => {
        if (sections[section].length === 1) return;

        setSections({
            ...sections,
            [section]: sections[section].filter((_, i) => i !== index)
        });
    };


    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("school_slug", school_slug);
        formData.append("sections", JSON.stringify(sections));

        Object.keys(sections).forEach(section => {
            sections[section].forEach((row, index) => {
                if (row.details instanceof File) {
                    formData.append(
                        `${section}_file_${index}`,
                        row.details
                    );
                }
            });
        });

        const res = await axios.post(
            `${baseAPIUrl}admin/academic_page/save_mandatory_disclosure`,
            formData,
            { withCredentials: true }
        );
        await fetchSection();
        setMessage(res.data.msg);
        scrollToTop();
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Mandatory Disclosure</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Mandatory Disclosure</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Mandatory Disclosure</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}

                                        {/* Uniform Details – Summer */}
                                        <div className="form-group">
                                            <h4>General information</h4>

                                            {sections.general_information.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Information"
                                                        value={row.information}
                                                        onChange={(e) =>
                                                            handleChange("general_information", index, "information", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Details"
                                                        value={row.details}
                                                        onChange={(e) =>
                                                            handleChange("general_information", index, "details", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("general_information", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("general_information")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                        {/* DOCUMENTS AND INFORMATION */}
                                        <div className="form-group">
                                            <h4>DOCUMENTS AND INFORMATION</h4>
                                            {sections.documents_information.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Information"
                                                        value={row.information}
                                                        onChange={(e) =>
                                                            handleChange("documents_information", index, "information", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Details"
                                                        value={row.details}
                                                        onChange={(e) =>
                                                            handleChange("documents_information", index, "details", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("documents_information", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("documents_information")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                        {/* RESULT AND ACADEMICS */}
                                        <div className="form-group">
                                            <h5>RESULT AND ACADEMICS</h5>
                                            {sections.result_academics.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Information"
                                                        value={row.information}
                                                        onChange={(e) =>
                                                            handleChange("result_academics", index, "information", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Details"
                                                        value={row.details}
                                                        onChange={(e) =>
                                                            handleChange("result_academics", index, "details", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("result_academics", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("result_academics")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                        
                                        {/* RESULT OF CLASS X */}

                                        <div className="form-group">
                                            <h4>RESULT OF CLASS X</h4>

                                            {sections.result_class_x.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2 flex-wrap">

                                                    <input
                                                        type="text"
                                                        placeholder="Year"
                                                        value={row.year}
                                                        onChange={(e) =>
                                                            handleChange("result_class_x", index, "year", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Registered Students"
                                                        value={row.registered}
                                                        onChange={(e) =>
                                                            handleChange("result_class_x", index, "registered", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Students Passed"
                                                        value={row.passed}
                                                        onChange={(e) =>
                                                            handleChange("result_class_x", index, "passed", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Pass Percentage"
                                                        value={row.percentage}
                                                        onChange={(e) =>
                                                            handleChange("result_class_x", index, "percentage", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Remark"
                                                        value={row.remark}
                                                        onChange={(e) =>
                                                            handleChange("result_class_x", index, "remark", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("result_class_x", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("result_class_x")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* RESULT OF CLASS XII */}

                                        <div className="form-group">
                                            <h4>RESULT OF CLASS XII</h4>

                                            {sections.result_class_xii.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2 flex-wrap">

                                                    <input
                                                        type="text"
                                                        placeholder="Year"
                                                        value={row.year}
                                                        onChange={(e) =>
                                                            handleChange("result_class_xii", index, "year", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Registered Students"
                                                        value={row.registered}
                                                        onChange={(e) =>
                                                            handleChange("result_class_xii", index, "registered", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Students Passed"
                                                        value={row.passed}
                                                        onChange={(e) =>
                                                            handleChange("result_class_xii", index, "passed", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Pass Percentage"
                                                        value={row.percentage}
                                                        onChange={(e) =>
                                                            handleChange("result_class_xii", index, "percentage", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Remark"
                                                        value={row.remark}
                                                        onChange={(e) =>
                                                            handleChange("result_class_xii", index, "remark", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("result_class_xii", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("result_class_xii")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* STAFF (TEACHING & NON-TEACHING) INFORMATION */}
                                        <div className="form-group">
                                            <h5>STAFF (TEACHING & NON-TEACHING) INFORMATION</h5>
                                            {sections.staff_information.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Information"
                                                        value={row.information}
                                                        onChange={(e) =>
                                                            handleChange("staff_information", index, "information", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Details"
                                                        value={row.details}
                                                        onChange={(e) =>
                                                            handleChange("staff_information", index, "details", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("staff_information", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("staff_information")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* SCHOOL INFRASTRUCTURE INFORMATION */}
                                        <div className="form-group">
                                            <h5>SCHOOL INFRASTRUCTURE INFORMATION</h5>
                                            {sections.infrastructure_information.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Information"
                                                        value={row.information}
                                                        onChange={(e) =>
                                                            handleChange("infrastructure_information", index, "information", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Details"
                                                        value={row.details}
                                                        onChange={(e) =>
                                                            handleChange("infrastructure_information", index, "details", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("infrastructure_information", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("infrastructure_information")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default MandatoryDisclosure;